/* eslint-disable */
import React, { useState } from 'react';
import {
  IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Divider,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import userIcon from 'Images/user_icon.svg';
import { PowerIcon } from './constants';
import CreateAccountDialog from './CreateAccountDialog';

const ClientActionsMenu = ({ row, onToggleStatus, onRefresh }) => {
  const [anchor, setAnchor] = useState(null);
  const [createOpen, setCreateOpen] = useState(false);
  return (
    <>
      <IconButton size="small" onClick={(e) => { e.stopPropagation(); setAnchor(e.currentTarget); }}>
        <MoreVertIcon sx={{ fontSize: 20 }} />
      </IconButton>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { boxShadow: '0 4px 20px rgba(0,0,0,0.1)', borderRadius: '8px', minWidth: 230 } } }}
      >
        <MenuItem onClick={() => { setAnchor(null); setCreateOpen(true); }} sx={{ py: '4px', px: '12px' }}>
          <ListItemIcon sx={{ minWidth: 'unset' }}>
            <img src={userIcon} alt="user" style={{ width: 18, height: 18 }} />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: '14px', color: '#385576', fontWeight: 600, ml: '-12px' }}>
            Créer un nouvel utilisateur
          </ListItemText>
        </MenuItem>
        <Divider sx={{ my: 0, mx: '12px' }} />
        <MenuItem onClick={() => { setAnchor(null); onToggleStatus(); }} sx={{ py: '4px', px: '12px' }}>
          <ListItemIcon sx={{ minWidth: 'unset' }}>
            <PowerIcon color={row.isEnabled ? '#EF446E' : '#0AD69F'} />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: '14px', color: row.isEnabled ? '#EF446E' : '#0AD69F', fontWeight: 600, ml: '-12px' }}>
            {row.isEnabled ? 'Désactiver le compte' : 'Activer le compte'}
          </ListItemText>
        </MenuItem>
      </Menu>

      {createOpen && (
        <CreateAccountDialog
          clientCode={row.code}
          onClose={() => setCreateOpen(false)}
          onSuccess={onRefresh}
        />
      )}
    </>
  );
};

export default ClientActionsMenu;
